import { useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";

const BodyImage = () => {

	const imageMapResizer = require('image-map-resizer');
	useEffect(() => {
		imageMapResizer();
	}, []);
	
	return (
		<>
			<div className="row">
				<div className="col-md-7">
				    <img src="https://orthopedics-diagnosis.com/diagnosis/images/diagnosis_body.jpg" useMap="#ImageMap" className="img-fluid" />
				    <map name="ImageMap">
				      <area shape="rect" coords="452,415,2311,912" href="./choice/2" alt="" />
				      <area shape="rect" coords="452,919,2311,1397" href="./choice/12" alt="" />
				      <area shape="rect" coords="452,1407,2311,1891" href="./choice/4" alt="" />
				      <area shape="rect" coords="452,1904,2311,2389" href="./choice/6" alt="" />
				      <area shape="rect" coords="452,2396,2311,2882" href="./choice/8" alt="" />
				      <area shape="rect" coords="452,2890,2311,3375" href="./choice/10" alt="" />
				      <area shape="rect" coords="452,3382,2311,3885" href="./choice/14" alt="" />
				      <area shape="rect" coords="3910,415,5744,912" href="./choice/1" alt="" />
				      <area shape="rect" coords="3910,919,5744,1397" href="./choice/3" alt="" />
				      <area shape="rect" coords="3910,1407,5744,1891" href="./choice/5" alt="" />
				      <area shape="rect" coords="3910,1904,5744,2389" href="./choice/7" alt="" />
				      <area shape="rect" coords="3910,2396,5744,2882" href="./choice/9" alt="" />
				      <area shape="rect" coords="3910,2890,5744,3375" href="./choice/13" alt="" />
				      <area shape="rect" coords="3910,3382,5744,3885" href="./choice/11" alt="" />
				    </map>
				</div>
				<div className="col-md-5 pt-3">
					<h3>痛みのある場所を画像、もしくは下記リンクから選択してください</h3>
					<div className="mb-1"><a href="./choice/1"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 首が痛い</a></div>
					<div className="mb-1"><a href="./choice/3"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 肩が痛い</a></div>
					<div className="mb-1"><a href="./choice/5"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 肘が痛い</a></div>
					<div className="mb-1"><a href="./choice/7"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 手首が痛い</a></div>
					<div className="mb-1"><a href="./choice/9"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 手・指が痛い</a></div>
					<div className="mb-1"><a href="./choice/12"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 腕が痛い</a></div>
					<div className="mb-1"><a href="./choice/2"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 背中が痛い</a></div>
					<div className="mb-1"><a href="./choice/4"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 腰が痛い</a></div>
					<div className="mb-1"><a href="./choice/6"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 股関節が痛い</a></div>
					<div className="mb-1"><a href="./choice/8"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 膝が痛い</a></div>
					<div className="mb-1"><a href="./choice/10"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 足首が痛い</a></div>
					<div className="mb-1"><a href="./choice/11"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 足・足の指が痛い</a></div>
					<div className="mb-1"><a href="./choice/13"><FontAwesomeIcon icon={faArrowAltCircleRight} /> 脚が痛い</a></div>
					<div className="mb-1"><a href="./choice/14"><FontAwesomeIcon icon={faArrowAltCircleRight} /> その他</a></div>
				</div>
			</div>
		</>
	);
};

export { BodyImage };
